import React, { FC } from 'react';
import { Link } from 'components/Link';
import { Control } from '@yleisradio/areena-types';
import { useIcon } from 'components/Controls/Control/useIcon';
import styles from './TextLinkControl.module.scss';
import { useControl } from 'components/Controls/Control/useControl';
import {
  isActivator,
  isNavigator,
} from 'components/Controls/Control/typeGuards';

type Props = { control: Control; onClick(): void };

const TextLinkControl: FC<Props> = ({ control: controlProp, onClick }) => {
  const Icon = useIcon(controlProp);
  const { control, action } = useControl({
    control: controlProp,
  });

  const handleOnClick = () => {
    if (action) action();
    onClick();
  };

  return (
    <>
      {isNavigator(control) && control.destination && (
        <Link
          pointer={control.destination}
          className={styles.link}
          onClick={onClick}
        >
          {Icon && <Icon className={styles.icon} aria-hidden />}
          <span className={styles.text}>{control.title}</span>
        </Link>
      )}
      {isActivator(control) && (
        <button className={styles.link} onClick={handleOnClick}>
          {Icon && <Icon className={styles.icon} aria-hidden />}
          <span className={styles.text}>{control.title}</span>
        </button>
      )}
    </>
  );
};

export { TextLinkControl };
